import { decode } from 'html-entities';

/**
 * Decodes an HTML-encoded string.
 *
 * ⚠️ If this is being called repeatedly for the same API fields,
 * prefer adding the route + fields to the `decode-html` Axios interceptor
 * instead of decoding in templates/components.
 *
 * @param input - HTML-encoded string
 * @param doubleDecode - Whether the value is encoded twice
 */
export const decodeHtml = (
  input?: string,
  doubleDecode?: boolean,
) => {
  if (input && input.length > 0) {
    const output = input.replace(/&Tab;&lt;li&gt;/g, '&lt;li&gt;');
    return doubleDecode ? decode(decode(output)) : decode(output);
  }

  return '';
};
